import { useContext } from 'react'
import { titleCase } from '@/content/casing'
import { defaultPrefs, PrefsContextValue } from './prefs'

/** Formats interface text in the visitor's chosen case; title case outside the provider. */
export function useCasing() {
  const casing = useContext(PrefsContextValue)?.prefs.casing ?? defaultPrefs.casing
  return (text: string) => (casing === 'title' ? titleCase(text) : text)
}
